const PAGE_MULTIPLIER = 0.8;
const LINE_HEIGHT = 15;

export const normalizeWheelDelta = (event: WheelEvent) => {
  let { deltaX } = event;
  let { deltaY } = event;

  if (event.deltaMode === 1) {
    deltaX *= LINE_HEIGHT;
    deltaY *= LINE_HEIGHT;
  } else if (event.deltaMode === 2) {
    const viewportHeight = window.innerHeight;
    deltaX *= viewportHeight * PAGE_MULTIPLIER;
    deltaY *= viewportHeight * PAGE_MULTIPLIER;
  }

  return { deltaX, deltaY };
};
